<div class="flex items-center w-full rounded-2xl">
  <app-global-deliverables-list
    class="w-full"
    data-testid="template-settings"
    [getExistingDeliverablesCount]="getExistingDeliverablesCountForGlobal"
    [getExistingExecutionsCount]="getExistingExecutionsCountForGlobal"
    [getExistingKpisCount]="getExistingKpisCountForGlobal"
    [globalAndSharedCtaValues]="globalTemplates()"
    [hideShareStatusIcon]="true"
    [loading]="store.templatesLoading$()"
    [isTemplateSettings]="true"
    (addDeliverablesForCta)="addTemplateDeliverables($event, EDeliverableFlowStep.deliverable)"
    (addExecutionsForCta)="addTemplateDeliverables($event, EDeliverableFlowStep.execution)"
    (addGlobalDeliverables)="addGlobalDeliverables()"
    (removeCtaGlobally)="removeTemplate($event)"
  />
</div>
